import { Button } from "@/components/ui";
import type { TaskType } from "@/types/content";
import { cn } from "@/utils/cn";

import { FormCard } from "./FormCard";

interface Props {
  taskTypes: TaskType[];
  selectedId: string | null;
  onSelect: (id: string) => void;
}

export const TaskTypeSelector = ({ taskTypes, selectedId, onSelect }: Props) => {
  if (taskTypes.length <= 1) return null;

  return (
    <FormCard>
      <label className="mb-3 block font-medium text-foreground text-sm">
        What do you want to create?
      </label>
      <div className="flex flex-wrap gap-2">
        {taskTypes.map((taskType) => (
          <Button
            key={taskType.id}
            onClick={() => onSelect(taskType.id)}
            variant={selectedId === taskType.id ? "default" : "outline"}
            className={cn(selectedId === taskType.id && "shadow-sm")}
          >
            {taskType.label}
          </Button>
        ))}
      </div>
    </FormCard>
  );
};
